import { useMemo } from 'react';
import type { CSSProperties } from 'react';
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core';

export interface DragHandle {
  attributes: DraggableAttributes;
  listeners: DraggableSyntheticListeners;
  setActivatorNodeRef: (element: HTMLElement | null) => void;
}

export const sameHandle = (a: DragHandle, b: DragHandle) =>
  a.attributes === b.attributes &&
  a.listeners === b.listeners &&
  a.setActivatorNodeRef === b.setActivatorNodeRef;

const noop = (_: HTMLElement | null) => {};
const emptyStyle: CSSProperties = {};
const emptyAttributes = {} as DraggableAttributes;

// dnd-kit hooks (useSortable) crash Safari 18. This stub returns no-op values
// so card components compile and render without drag wiring.
export const useSortableCard = (_id: string, _disabled: boolean, _data?: Record<string, unknown>) => {
  const handle = useMemo<DragHandle>(
    () => ({ attributes: emptyAttributes, listeners: undefined, setActivatorNodeRef: noop }),
    []
  );
  return { setNodeRef: noop, style: emptyStyle, handle };
};
